// extracted by mini-css-extract-plugin
export default {"w1000":"style_w1000_QJQEM","clearfix":"style_clearfix_dz3zM"};